/** @type {import('../schema').ProcessDefinition} */
const asambleas = {
  id: "asambleas",
  name: "Asambleas de copropietarios",
  category: "operaciones",
  outcome:
    "Convocar a los propietarios (app, WhatsApp o en mano), registrar quién asiste y documentar las decisiones en el acta.",
  trigger: "El Administrador crea la asamblea: fecha, hora, modalidad y orden del día.",
  actors: ["Administrador", "Bot Habi", "Propietario"],
  status: "PARCIAL",
  description:
    "Fase 1 operativa detrás del interruptor asambleas_config/global: convocatoria solo a propietarios vigentes, confirmación por app, WhatsApp o enlace personal, recordatorio el día anterior y calendario. El acta desde el audio sigue en la herramienta anterior hasta la Fase 2 (acta borrador con aprobación y publicación a propietarios).",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "bot", actor: "Bot Habi" },
    { id: "prop", actor: "Propietario" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Crea la asamblea", description: "Fecha, hora, modalidad (presencial, remota o mixta), lugar y orden del día.", evidence: "src/screens/admin/asambleas/AsambleaFormModal.jsx" },
    { id: "s2", laneId: "admin", type: "task", label: "Convoca a los propietarios", description: "Avisa plazos (10 días, documentos 48 h) y envía la citación solo a propietarios vigentes.", evidence: "functions/asambleas/index.js (asambleaAdmin convocar)" },
    { id: "s3", laneId: "bot", type: "task", label: "Envía la citación", description: "WhatsApp con botones o email; sin domicilio electrónico, citación en papel con constancia.", evidence: "functions/asambleas/index.js (procesarEnvios)" },
    { id: "s4", laneId: "prop", type: "decision", label: "¿Asiste?", description: "Confirma por la app, el botón de WhatsApp o su enlace personal; puede agregarla al calendario.", evidence: "src/components/asambleas/AsambleaCard.jsx" },
    { id: "s5", laneId: "bot", type: "task", label: "Recordatorio D-1", description: "Pide confirmar a quien no respondió y recuerda a quien confirmó.", evidence: "functions/asambleas/index.js (procesarRecordatorios)" },
    { id: "s6", laneId: "admin", type: "task", label: "Captura audio o transcripción", description: "Herramienta anterior hasta la Fase 2: sube el audio o pega la transcripción.", evidence: "src/screens/admin/Asambleas.jsx" },
    { id: "s7", laneId: "bot", type: "document", label: "Genera el acta", description: "Redacta el acta a partir de la transcripción.", evidence: "Asambleas.jsx (/api/process-meeting-audio)" },
    { id: "s8", laneId: "prop", type: "end", label: "Propietarios reciben el acta" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5", label: "sin respuesta / sí" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
  ],
};

export default asambleas;
